import React from 'react';
import styled, { css } from 'styled-components';
import { ComponentRenderer as ComponentRendererOG } from '@cmpsr/contentful-core/lib/components';
import { normalize } from 'styled-normalize';
const StyledComponentRenderer = styled(ComponentRendererOG)`
  ${({
  theme
}) => {
  var _theme$fonts;

  const fonts = ((_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : _theme$fonts.map(font => `@font-face { 
              font-family: '${font.name}'; 
              src: url('${font.url}') format('${font.format}'); 
              font-weight: ${font.weight};
            };`).join('')) || '';
  return css`
      ${normalize}
      ${fonts}
      
      * {
        box-sizing: border-box;
      }

      color: ${theme.color};

      span,
      p,
      li {
        font-family: ${theme.textStyles[5].md.fontFamily};
        font-weight: ${theme.textStyles[5].md.fontWeight};
        font-size: ${theme.textStyles[5].md.fontSize};
        line-height: ${theme.textStyles[5].md.lineHeight};
        margin: ${theme.textStyles[5].md.margin};
      }

      p span {
        margin: 0;
      }

      h1,
      h1 span {
        font-family: ${theme.textStyles[1].md.fontFamily};
        font-weight: ${theme.textStyles[1].md.fontWeight};
        font-size: ${theme.textStyles[1].md.fontSize};
        line-height: ${theme.textStyles[1].md.lineHeight};
        margin: ${theme.textStyles[1].md.margin};
      }

      h2,
      h2 span {
        font-family: ${theme.textStyles[2].md.fontFamily};
        font-weight: ${theme.textStyles[2].md.fontWeight};
        font-size: ${theme.textStyles[2].md.fontSize};
        line-height: ${theme.textStyles[2].md.lineHeight};
        margin: ${theme.textStyles[2].md.margin};
      }

      h3,
      h3 span {
        font-family: ${theme.textStyles[3].md.fontFamily};
        font-weight: ${theme.textStyles[3].md.fontWeight};
        font-size: ${theme.textStyles[3].md.fontSize};
        line-height: ${theme.textStyles[3].md.lineHeight};
        margin: ${theme.textStyles[3].md.margin};
      }

      h4,
      h4 span,
      h5,
      h5 span,
      h6,
      h6 span {
        font-family: ${theme.textStyles[4].md.fontFamily};
        font-weight: ${theme.textStyles[4].md.fontWeight};
        font-size: ${theme.textStyles[4].md.fontSize};
        line-height: ${theme.textStyles[4].md.lineHeight};
        margin: ${theme.textStyles[4].md.margin};
      }

      label {
        font-family: ${theme.textStyles[7].md.fontFamily};
        font-weight: ${theme.textStyles[7].md.fontWeight};
        font-size: ${theme.textStyles[7].md.fontSize};
        line-height: ${theme.textStyles[7].md.lineHeight};
        margin: ${theme.textStyles[7].md.margin};
      }

      a {
        font-family: ${theme.textStyles[8].md.fontFamily};
        font-weight: ${theme.textStyles[8].md.fontWeight};
        font-size: ${theme.textStyles[8].md.fontSize};
        line-height: ${theme.textStyles[8].md.lineHeight};
        margin: 0;
      }

      button {
        font-family: ${theme.textStyles[9].md.fontFamily};
        font-weight: ${theme.textStyles[9].md.fontWeight};
        font-size: ${theme.textStyles[9].md.fontSize};
        line-height: ${theme.textStyles[9].md.lineHeight};
      }

      @media (max-width: 900px) {
        span,
        p,
        li {
          font-family: ${theme.textStyles[5].sm.fontFamily};
          font-weight: ${theme.textStyles[5].sm.fontWeight};
          font-size: ${theme.textStyles[5].sm.fontSize};
          line-height: ${theme.textStyles[5].sm.lineHeight};
          margin: ${theme.textStyles[5].sm.margin};
        }

        body {
          color: ${theme.color};
        }

        h1,
        h1 span {
          font-family: ${theme.textStyles[1].sm.fontFamily};
          font-weight: ${theme.textStyles[1].sm.fontWeight};
          font-size: ${theme.textStyles[1].sm.fontSize};
          line-height: ${theme.textStyles[1].sm.lineHeight};
          margin: ${theme.textStyles[1].sm.margin};
        }

        h2,
        h2 span {
          font-family: ${theme.textStyles[2].sm.fontFamily};
          font-weight: ${theme.textStyles[2].sm.fontWeight};
          font-size: ${theme.textStyles[2].sm.fontSize};
          line-height: ${theme.textStyles[2].sm.lineHeight};
          margin: ${theme.textStyles[2].sm.margin};
        }

        h3,
        h3 span {
          font-family: ${theme.textStyles[3].sm.fontFamily};
          font-weight: ${theme.textStyles[3].sm.fontWeight};
          font-size: ${theme.textStyles[3].sm.fontSize};
          line-height: ${theme.textStyles[3].sm.lineHeight};
          margin: ${theme.textStyles[3].sm.margin};
        }

        h4,
        h4 span,
        h5,
        h5 span,
        h6,
        h6 span {
          font-family: ${theme.textStyles[4].sm.fontFamily};
          font-weight: ${theme.textStyles[4].sm.fontWeight};
          font-size: ${theme.textStyles[4].sm.fontSize};
          line-height: ${theme.textStyles[4].sm.lineHeight};
          margin: ${theme.textStyles[4].sm.margin};
        }

        label {
          font-family: ${theme.textStyles[7].sm.fontFamily};
          font-weight: ${theme.textStyles[7].sm.fontWeight};
          font-size: ${theme.textStyles[7].sm.fontSize};
          line-height: ${theme.textStyles[7].sm.lineHeight};
          margin: ${theme.textStyles[7].sm.margin};
        }

        a {
          font-family: ${theme.textStyles[8].sm.fontFamily};
          font-weight: ${theme.textStyles[8].sm.fontWeight};
          font-size: ${theme.textStyles[8].sm.fontSize};
          line-height: ${theme.textStyles[8].sm.lineHeight};
          margin: 0;
        }

        button {
          font-family: ${theme.textStyles[9].sm.fontFamily};
          font-weight: ${theme.textStyles[9].sm.fontWeight};
          font-size: ${theme.textStyles[9].sm.fontSize};
          line-height: ${theme.textStyles[9].sm.lineHeight};
        }
      }
    `;
}}
`;
export const ComponentRenderer = props => {
  return /*#__PURE__*/React.createElement(StyledComponentRenderer, props);
};